module.exports = __webpack_public_path__ + "static/media/icon-cancel-red.52669809.svg";